import { render, staticRenderFns } from "./proceed_list_pc.vue?vue&type=template&id=588117b6&scoped=true&"
import script from "./proceed_list_pc.vue?vue&type=script&lang=js&"
export * from "./proceed_list_pc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588117b6",
  null
  
)

export default component.exports